import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ArpioAlertComponent } from './components/arp-alert/arpio-alert.component'

const routes: Routes = [
  {
    path: '',
    component: ArpioAlertComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArpioAlertRoutingModule {}
